import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useSession } from '@/api/session-context';
import LoadingScreen from '@/components/ui/LoadingScreen';
import { ROUTES } from '@/router/paths';

export default function AuthGuard({ children }: { children: ReactNode }) {
  const location = useLocation();
  const session = useSession();

  if (session.status === 'initializing') {
    return <LoadingScreen label="Проверяем сессию…" />;
  }

  if (session.status === 'anonymous') {
    const destination = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={ROUTES.login} replace state={{ from: destination }} />;
  }

  if (session.status === 'unavailable') {
    return (
      <main className="flex min-h-dvh items-center justify-center bg-surface-50 px-4">
        <section className="raised-panel w-full max-w-md rounded-lg border border-surface-200 p-6 text-center">
          <i className="ri-cloud-off-line text-3xl text-accent-600" aria-hidden="true" />
          <h1 className="mt-3 text-lg font-semibold text-surface-900">
            Не удалось проверить сессию
          </h1>
          <p className="mt-2 text-sm leading-6 text-surface-500">
            Сервис авторизации временно недоступен. Проверьте соединение и повторите попытку.
          </p>
          <button
            type="button"
            onClick={() => void session.retry()}
            className="mt-5 rounded-md bg-accent-500 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-accent-600"
          >
            Повторить
          </button>
        </section>
      </main>
    );
  }

  return children;
}
